module.exports = __webpack_public_path__ + "static/media/align-center.8d57094b.svg";